enum SocialMediaType {
    TIKTOK = 'tiktok'
}

export default SocialMediaType